import useNav from '../hooks/useNav';
import useBeacon, { ClkBtnSubEventNm } from '../hooks/useBeacon';
import { useTermBottomsheet } from '../hooks/useTermBottomsheet';
import { TERM_CREDIT_LOAN, TERM_MTG_LOAN } from '../staticData/terms';
import { useTermFullsheet } from '../hooks/useTermFullsheet';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBridge } from '../hooks/useBridge';
import { useRecoilState, useRecoilValue } from 'recoil';
import { beaconSelector } from '../recoil/selector';
import { PAGE_NM, SORT_KEY } from '../types/types';
import { useTerms } from '../hooks/useTerms';
import { fetchHousePreList } from '../../infra/api/mtg/fetchHousePreList';
import * as Atom from '../recoil';
import { useBaseParam } from '../hooks/useBaseParam';
import { currencyKR } from '../helper/filter';
import { fetchHouseReqList } from '../../infra/api/mtg/fetchHouseReqList';
import useBlocker from '../hooks/useBlocker';
import moment from 'moment';
import useTermsBloc from '../hooks/useTermsBloc';

export const useMtgResult = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_RESULT,
  });
  const sendBeaconClkBtn = (subEventNm: string, properties: any) => {
    beacon.sendClkBtn({
      events: { subEventName: subEventNm },
      properties:
        typeof properties === 'string' ? { btnNm: properties } : properties,
    });
  };
  const sendBeaconClkBtnAgree = (btnNm: string) => {
    beacon.sendClkBtnAgree({
      properties: { btnNm },
    });
  };

  const [isOpenFilter, setOpenFilter] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useRecoilState(Atom.filter);

  const [popup, setPopup] = useState<any>({
    open: false,
    message: '',
    confirmText: '',
    cancelText: '',
    onClickCancel: () => {},
    onClickConfirm: () => {},
  });

  const [bottomsheet, setBottomsheet] = useState<any>({
    isOpen: false,
    title: '',
    close: () => {},
    children: '',
  });
  const openBottomsheet = (val: string) => {
    setBottomsheet((prev: any) => {
      return {
        isOpen: true,
        title: val,
        close: () =>
          setBottomsheet(() => {
            return { ...prev, isOpen: false };
          }),
      };
    });
  };
  const openTermBottomsheet = () => {
    termBottomsheet.open();
  };

  const [isBridgeModal, setIsBridgeModal] = useState<boolean>(false);
  const { media } = useParams();
  const br: any = useBridge();
  const { navigate, navigateMtgMain } = useNav();
  const navigateSurvey = () => {
    navigate(
      `/survey/mgt_pre_req/${preList.housePreRequestInfoData.preRequestSeq}`,
    );
  };
  const navigateDetail = (requestSeq: number, preRequestDtlNo: number) => {
    navigate(`/mtg/detail/${requestSeq ?? 0}/${preRequestDtlNo}`);
  };

  const navigateDA = (media?: string) => {
    setIsBridgeModal(false);
    // todo navigateByLinkType
    if (media === 'skt') {
      br?.requestAddService({
        type: 'EBMP',
        url:
          process.env.REACT_APP_EBMP_SKT_URI +
          '?extraParam=3&extraParam2=A007BA01',
      });
    } else if (media === 'kt') {
      br?.requestAddService({
        type: 'EBMP',
        url: process.env.REACT_APP_EBMP_KT_URI + '?src_cd=D007BA01',
      });
    } else {
      // todo lgu 인터페이스 규격 추가 시 수정
      br?.goNativeMain();
    }
  };
  const navigatePurpose = () => {
    navigate('/mtg/conditions/1', { state: { ref_page: '/mtg/result' } });
  };

  const navigateCredit = () => {
    navigate('/main', { replace: true });
  };

  const navigateCreditCond = () => {
    const path =
      process.env.REACT_APP_ENV !== 'production'
        ? '/conditions/2'
        : '/conditions/1';
    navigate(path, { state: '', replace: true });
  };

  const termBottomsheet = useTermBottomsheet(TERM_MTG_LOAN, 'all');
  const termFullsheet = useTermFullsheet();

  const creditTermBottomsheet = useTermBottomsheet(TERM_CREDIT_LOAN, 'all');
  const creditTermFullsheet = useTermFullsheet();

  const openTermFullsheet = (checkItemIdx: number) => {
    termBottomsheet.expandItem(null, checkItemIdx);
  };

  const openCreditTermFullsheet = (checkItemIdx: number) => {
    creditTermBottomsheet.expandItem(null, checkItemIdx);
  };

  const onClickSubText = (item: any, _: number) => {
    const { title, path, termsCd } = item;
    termFullsheet.open(title, path, termsCd);
  };

  const onClickCreditSubText = (item: any, _: number) => {
    const { title, path, termsCd } = item;
    creditTermFullsheet.open(title, path, termsCd);
  };

  const terms = useTerms({
    EVENT_STATE: 'mtg',
    ref_page: PAGE_NM.MTG_HOME,
  });

  const creditTerms = useTerms();

  const [isLoading, setLoading] = useState(true);

  const [preList, setPreList] = useState<any>({});
  const [personal] = useRecoilState(Atom.personalInfo);
  const [preRequestSeq, setPreRequestSeq] = useState<number | undefined>();
  const fetchPreList = useBaseParam(fetchHousePreList, {
    custSeq: personal.custSeq,
  });
  const fetchHouseReq = useBaseParam(fetchHouseReqList, {
    custSeq: personal.custSeq,
  });

  const getPreList = async () => {
    const response = await fetchPreList();
    const housePreList = await response.data.result;

    if (housePreList) {
      // 만원 단위 처리
      Atom.resetAmtUnit(housePreList.housePreRequestInfoData);
      setPreRequestSeq(housePreList.housePreRequestInfoData.preRequestSeq);
      setPreList(() => {
        return {
          minRateProductItem: housePreList.minRateProductItem,
          maxAmountProductItem: housePreList.maxAmountProductItem,
          housePreRequestInfoData: housePreList.housePreRequestInfoData,
          allList: housePreList?.allProductItemList.map((item: any) => {
            const isMinRate =
              item?.housePreProductInfo?.preRequestDtlNo ===
              housePreList.minRateProductItem.housePreProductInfo
                .preRequestDtlNo;
            const isMaxAmt =
              item?.housePreProductInfo?.preRequestDtlNo ===
              housePreList.maxAmountProductItem.housePreProductInfo
                .preRequestDtlNo;
            const stateChip = [
              isMaxAmt ? { color: 'secondary', text: '최대 한도' } : null,
              isMinRate ? { color: 'info', text: '최저 금리' } : null,
            ].filter((v) => v != null);
            return {
              key: item?.houseProductInfo?.productHouseSeq,
              benefitText: '',
              eventChip: item?.houseProductInfo?.productHouseChipList
                .map((item: any) => {
                  return {
                    type: 'event',
                    text: item.displayText,
                    backgroundColor: item.backgroundColor,
                    borderColor: item.borderColor,
                    order: item.displayOrderChip,
                  };
                })
                .sort((a: any, b: any) => {
                  return a.order - b.order;
                }),
              stateChip: stateChip,
              preRequestDtlNo: item?.housePreProductInfo?.preRequestDtlNo,
              requestSeq: item?.houseRequestProductInfo?.requestSeq,
              amount: item?.housePreProductInfo?.amount,
              limit: item?.housePreProductInfo?.interestRate,
              logoImgUrl: item?.houseProductInfo?.logoImg,
              companyNm: item?.houseProductInfo?.compNm,
              productHouseSeq: item?.houseProductInfo?.productHouseSeq,
              productNm: item?.houseProductInfo?.productNm,
              limitValue: item?.housePreProductInfo?.amount,
              interestRate: item?.housePreProductInfo?.interestRate,
            };
          }),
        };
      });
    }

    setLoading(false);
  };

  const [sortValue, setSortValue] = useState<number>(SORT_KEY.LOW_RATE);
  const getFilteredList = () => {
    if (!Array.isArray(preList?.allList)) return;

    let filtered = preList?.allList?.map((item: any) => ({
      ...item,
    }));

    filtered = filtered.filter((item: any) => {
      const { amount, interestRate } = item;
      return (
        amount >= filterValue.limit && interestRate <= filterValue.interest
      );
    });

    return filtered.sort((a: any, b: any) => {
      if (sortValue === SORT_KEY.LOW_RATE) {
        // 금리 기준 정렬
        // 일차로 금리가 낮은 순으로 보여주고 같은 경우에는 한도가 높은 항목을 먼저 보여준다.
        return a.interestRate - b.interestRate || b.amount - a.amount;
      } else if (sortValue === SORT_KEY.MAX_AMOUNT) {
        // 한도 기준 정렬
        // 일차로 한도가 높은 순으로 보여주고 같은 경우에는 금리가 낮은 순서로 보여준다.
        return b.amount - a.amount || a.interestRate - b.interestRate;
      }
    });
  };

  useEffect(() => {
    setLoading(true);

    if (personal.custSeq) {
      void getPreList();
    }
  }, [personal]);

  useEffect(() => {
    if (preRequestSeq) {
      const products = preList?.allList?.map((p: any) => p.productHouseSeq);
      beacon.sendViewPage({
        properties: {
          preRequestSeq: preRequestSeq,
          hasResult: products && products.length > 0,
          products: products,
        },
      });
    }
  }, [preRequestSeq]);

  const showPopupForCreditLoan = () => {
    setShouldBlock(false);
    setFilterValue({
      limit: 0,
      interest: 20,
    });
    setPopup({
      open: true,
      message:
        '주택담보대출 신청이 완료되지 않았어요.\n신용대출 상품도 비교를 통해 알아볼까요?',
      confirmText: '네',
      cancelText: '메인으로',
      onClickCancel: () => {
        // navigate("/mtgMain", {replace: true});
        sendBeaconClkBtn('go_mtg_main', '');
        navigateMtgMain();
        setPopup({
          ...popup,
          open: false,
        });
      },
      onClickConfirm: async () => {
        sendBeaconClkBtn(ClkBtnSubEventNm.GoCreMain, '');
        // navigateCredit();
        if (media === 'lgu') {
          await creditTerms.processAgreeTermLgu2(() => {
            setShouldBlock(false);
            setFilterValue({
              limit: 0,
              interest: 20,
            });
            navigateCreditCond();
          });
        } else {
          creditTermBottomsheet.open();
        }

        setPopup({
          ...popup,
          open: false,
        });
      },
    });
  };

  const { agree }: any = useTermsBloc(media, '01');
  const processCreditTerm = async () => {
    const res = await agree();
    if (res.isSuccess) {
      navigateCreditCond();
    }
  };

  const showPopupForConfirm = () => {
    setShouldBlock(false);
    setFilterValue({
      limit: 0,
      interest: 20,
    });
    setPopup({
      open: true,
      message: '내일은 대출 조건이 달라질 수 있어요.\n그래도 나가시겠어요?',
      confirmText: '아니요',
      cancelText: '네',
      onClickCancel: () => {
        // navigate("/mtgMain", {replace: true});
        sendBeaconClkBtn('go_mtg_main', '');
        navigateMtgMain();
        setPopup({
          ...popup,
          open: false,
        });
      },
      onClickConfirm: () => {
        sendBeaconClkBtn('stay', '');
        setPopup({
          ...popup,
          open: false,
        });
      },
    });
  };

  const [shouldBlock, setShouldBlock] = useState<any>(true);

  useBlocker((tx: any) => {
    if (tx.action == 'PUSH') {
      tx.retry();
      return;
    }

    sendBeaconClkBtn('back', '');
    if (!preList?.allList || preList.allList.length <= 0) {
      tx.retry();
      return;
    }

    const currentPreRequestSeq =
      preList?.housePreRequestInfoData?.preRequestSeq ?? 0;
    if (currentPreRequestSeq <= 0) {
      tx.retry();
      return;
    }

    fetchHouseReq()
      .then((response) => {
        if (!response?.data?.isSucceed) {
          showPopupForConfirm();
          return;
        }

        if (!response.data.result) {
          showPopupForCreditLoan();
          return;
        }

        const requestList = response.data.result as any[];
        if (requestList.length <= 0) {
          showPopupForCreditLoan();
          return;
        }

        const hasTodayRequest =
          requestList.filter((item: any) => {
            const product = item?.houseCustProductInfo?.houseRequestProductInfo;
            if (!product) return false;

            const today = moment().format('YYYY-MM-DD');
            const { preRequestSeq, regDate } = product;
            // 같은 가심사에서만 볼것인지 아닌지 확인이 필요
            return (
              preRequestSeq === currentPreRequestSeq &&
              today === regDate.substring(0, 10)
            );
          }).length > 0;

        if (hasTodayRequest) {
          showPopupForConfirm();
        } else {
          showPopupForCreditLoan();
        }
      })
      .catch((e: any) => {
        showPopupForConfirm();
        return;
      });
  }, shouldBlock);

  return {
    isLoading,
    setOpenFilter,
    isOpenFilter,
    filterValue,
    mtgInfo: [
      {
        label: '대출 목적',
        value: preList?.housePreRequestInfoData?.purposeCdNm,
      },
      { label: '주택 주소', value: preList?.housePreRequestInfoData?.areaName },
      {
        label: '생애 첫 주택 구매 여부',
        value:
          preList?.housePreRequestInfoData?.firstYn === 'Y'
            ? '첫 구매에요'
            : '첫 구매가 아니에요',
      },
      {
        label: '세입자 유무',
        value:
          preList?.housePreRequestInfoData?.tenantYn === 'Y'
            ? '세입자 있어요'
            : '세입자 없어요',
      },
      {
        label: '보유 중인 대출 잔액',
        value: currencyKR(
          preList?.housePreRequestInfoData?.previousAmt * 10000,
        ),
      },
      {
        label: '대출 희망 금액',
        value: currencyKR(preList?.housePreRequestInfoData?.hopefulAmt * 10000),
      },
    ],
    hasResult: preList && preList.allList && preList.allList.length > 0,
    filteredList: getFilteredList(),
    mtgSummary: {
      mtgNm: preList?.housePreRequestInfoData?.areaName,
      minRateProductItem: preList?.minRateProductItem?.housePreProductInfo,
      maxAmountProductItem: preList?.maxAmountProductItem?.housePreProductInfo,
    },
    media,

    popup,
    setFilterValue,
    openBottomsheet,
    openTermBottomsheet,

    isBridgeModal,

    sendBeaconClkBtn,
    sendBeaconClkBtnAgree,

    navigateSurvey,
    navigateDetail,
    navigateDA,
    navigatePurpose,
    navigateCredit,
    navigateCreditCond,

    termFullsheet,
    termBottomsheet,
    openTermFullsheet,
    onClickSubText,

    creditTermFullsheet,
    creditTermBottomsheet,
    openCreditTermFullsheet,
    onClickCreditSubText,
    processCreditTerm,

    bottomsheet,
    sortValue,
    setSortValue,

    terms,
    regDate: preList?.housePreRequestInfoData?.regDate,
    setShouldBlock,
  };
};
